import { render, staticRenderFns } from "./rintingDetails.vue?vue&type=template&id=489990f6&scoped=true&"
import script from "./rintingDetails.vue?vue&type=script&lang=js&"
export * from "./rintingDetails.vue?vue&type=script&lang=js&"
import style0 from "./rintingDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./rintingDetails.vue?vue&type=style&index=1&id=489990f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489990f6",
  null
  
)

export default component.exports